import { TrustedPartner } from 'embed/components/TrustedPartners'

export const Avant: TrustedPartner = {
  logoUrl: 'https://assets.evenfinancial.com/requested/191212/AvantLogo.png',
  name: 'Avant, LLC',
  uuid: 'd6d6e812-a1c4-46c8-8296-d674115b4099',
}

export const Deserve: TrustedPartner = {
  logoUrl: 'https://images.evenfinancial.com/logos/Deserve/logo-deserve.svg',
  name: 'Deserve, Inc.',
  uuid: 'bbc5c59d-7ade-43e7-ab19-9ef934444b2c',
}

export const Jasper: TrustedPartner = {
  logoUrl: 'https://images.evenfinancial.com/logos/luxury/jasper_logo.png',
  name: 'Jasper',
  uuid: '27e5eb64-66bd-4245-9e77-626b40177758',
}

export const Upgrade: TrustedPartner = {
  logoUrl: 'https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80.png',
  name: 'Upgrade',
  uuid: '4499a3b5-caaf-470f-9719-2c5ba9c731b9',
}
